import React from 'react';
import { Box } from '@chakra-ui/react';
import { Header } from '../../components/shared/IndexHeader';
import { darkMode, lightMode } from '../../theme/config';
import CateloguesTab from './CateloguesTab';
import { useColorModeValue } from '../../components/ui/color-mode';

const ModelManagement = () => {
  const borderColor = useColorModeValue(lightMode.containerBorderColor, darkMode.containerBorderColor);
  const textColor = useColorModeValue(lightMode.textColor, darkMode.textColor);

  return (
    <Box border={{ base: '', md: '1px solid' }} borderColor={{ base: '', md: borderColor }} p={{ base: 3, md: 6 }} borderRadius="sm">
      <Header title="Model Management" subtitle="Manage product models and their details" textColor={textColor} fontWeight={700} />

      {/* Reuse existing CateloguesTab for the catalogue table and dialogs */}
      <Box mt={4}>
        <CateloguesTab activeTab={'catalogues'} />
      </Box>
    </Box>
  );
};

export default ModelManagement;
